<div class="cover-tile" droppable (onDrop)="attachImage($event)">
  <div class="image-container">
    <div class="cover-text" [hidden]="!!coverPage.documentId">
      <div class="main-text">Cover image</div>
      <div class="sub-text">Please drag and drop an image here.<br/>Files accepted are: jpg,jpeg, png, gif</div>
    </div>
    <img #coverImage/>
  </div>
  <div class="description-container" [hidden]="!(!!coverPage.documentId)">
    <span>Welcome Message</span>
    <form #coverForm="ngForm">
      <textarea name="description" [(ngModel)]="coverPage.description" class="form-control rounded-0 border-0" rows="2" (blur)="onSave()"></textarea>
    </form>
  </div>
</div>
